export const description_width = (invoice) => {
  return 12 - (invoice.settings.use_qty_price ? 2 : 0) - (invoice.settings.use_units ? 1 : 0) - (invoice.settings.use_vat ? 2 : 0) - 3
}